export default __webpack_public_path__ + "static/media/arrow-right.f346d3df.svg";